class UIHint {
    class = {
        light: 'light',
        is_active: 'is-active'
    };

    selectors = {
        active_hint: '.hint-wrapper.is-active'
    };

    teleports = [];

    constructor() {
        const that = this;

        that.resize_watcher = that.resizeWatcher();
        that.scroll_watcher = that.scrollWatcher();

        that.initEventHandlers();
    }

    initEventHandlers() {
        const that = this;

        $.sa.$document.on('click', '.js-hint-button', function(event) {
            event.preventDefault();
            event.stopPropagation();

            const $button = $(this),
                  $wrapper = $button.parents('.hint-wrapper');

            const is_active = $wrapper.hasClass(that.class.is_active);
            if (is_active) {
                that.hideAll();
            } else {
                that.show($wrapper, $button);    
            }
        });

        $.sa.$document.on('click', '.js-hint-close', function(event) {
            event.preventDefault();
            event.stopPropagation();
            that.hideAll();
        });

        $.sa.$document.on('click touchstart', function(event) {
            const is_click_on_hint = !!event.target.closest('.hint-wrapper'),
                  is_click_on_teleport = !!event.target.closest(UITeleport.selector);

            if (!is_click_on_hint && !is_click_on_teleport) {
                that.hideAll();
            }
        });
    }

    show($wrapper, $target) {
        const that = this;

        that.hideAll();

        setTimeout(function () {
            ($.sa.is_mobile() ? showModal() : showHint());
        }, 0);

        function showHint() {
            const $content = $wrapper.find('.hint');

            formatPositionClass($wrapper);
            
            const teleport = new UITeleport($target, {
                $wrapper: $wrapper,
                $content: $content,
                class_name: ($wrapper.hasClass(that.class.light) ? that.class.light : null),
                indent: 8
            });
            that.teleports.push(teleport);

            $wrapper.addClass(that.class.is_active);

            that.resize_watcher.on();
            that.scroll_watcher.on();

            function formatPositionClass($element) {
                // Частные случаи
                if ($element.hasClass('top')) {
                    $element.removeClass('top');

                    if ($element.hasClass('left')) {
                        $element
                            .removeClass('left')
                            .addClass(UITeleport.directions.top_left);
                    } else {
                        $element.addClass(UITeleport.directions.top_right);
                    }

                } else if ($element.hasClass('left')) {
                    $element
                        .removeClass('left')
                        .addClass(UITeleport.directions.left_bottom);

                } else if ($element.hasClass('right')) {
                    $element
                        .removeClass('right')
                        .addClass(UITeleport.directions.right_bottom);
                }
            }
        }

        function showModal() {
            const $title = $wrapper.find('.js-hint-title'),
                  $content = $wrapper.find('.js-hint-content');

            $.uiModal({
                header_title: ($title.length ? $title.html() : null),
                content: $content.html()
            });
        }
    }

    hideAll() {
        const that = this;

        $.sa.$document.find('.hint-wrapper.' + that.class.is_active).each( function() {
            $(this).removeClass(that.class.is_active);
        });

        that.teleports.forEach( function(teleport) {
            teleport.close();
        });

        that.teleports = [];

        that.resize_watcher.off();
        that.scroll_watcher.off();
    }

    /**
     * @description Наблюдатель закрывает открытые подсказки при resize-событии 
     * @return {Object}
     * */
    resizeWatcher() {
        const that = this;

        const $window = $.sa.$window;

        let is_active = false;

        return { on, off };

        function on() {
            if (is_active) { return false; }
            is_active = true;

            $window.on('resize', onResize);
        }

        function off() {
            if (!is_active) { return false; }
            is_active = false;

            $window.off('resize', onResize);
        }
        
        function onResize() {
            that.hideAll();
            off();
        }
    }

    scrollWatcher() {
        const that = this;

        let is_active = false;

        return { on, off };

        function on() {
            if (is_active) { return false; }
            is_active = true;

            document.addEventListener('scroll', onScroll, true);
        }

        function off() {
            if (!is_active) { return false; }
            is_active = false;

            document.removeEventListener('scroll', onScroll);
        }

        function onScroll(event) {
            const $target = $(event.target);

            // Если внутри элемента есть открытая подсказка, то закрываем подсказку
            const $active_hints = $target.find(that.selectors.active_hint);
            if ($active_hints.length) {
                that.hideAll();
                off();
            }
        }
    }
}